import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import 'katex/dist/katex.min.css';
import './cl-markdown.css';

export interface MarkdownTextViewProp {
  initData?: string;
  isPdf?: boolean;
}

export const MarkdownTextView = (props: MarkdownTextViewProp) => {
  const { initData = '', isPdf = false } = props;

  // Preserve line breaks but never touch math segments (so \neq, \nabla, etc. stay intact).
  const mathSegments: string[] = [];
  const withoutMath = initData.replace(/(\${1,2})([\s\S]*?)\1/g, (segment) => {
    const token = `__MATH_SEGMENT_${mathSegments.length}__`;
    mathSegments.push(segment);
    return token;
  });
  const normalizedData = withoutMath
    .replace(/\\r\\n/g, '\n')
    .replace(/\\n/g, '\n')
    .replace(
      /__MATH_SEGMENT_(\d+)__/g,
      (_, index) => mathSegments[Number(index)] ?? '',
    );

  return (
    <div
      className="max-w-none cl-markdown"
      style={{
        wordBreak: 'break-word',
        fontSize: '16px',
        lineHeight: isPdf ? '1.8 !important' : '1.8 !important',
      }}
    >
      <ReactMarkdown
        children={normalizedData}
        remarkPlugins={[remarkMath, remarkBreaks, remarkGfm]}
        rehypePlugins={[rehypeKatex, rehypeRaw]}
        components={{
          p: ({ children }) => <p style={{ margin: 0 }}>{children}</p>,
        }}
      />
    </div>
  );
};
